import { ValuableNode } from '../../models/ValuableNode'

export class SchemaUndefinedNode extends ValuableNode {}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Undefined': SchemaUndefinedNode
  }
}
